import { MsalConfiguration } from '#services';

export const environment = {
  envName: 'test',
  production: false,
  apiUrl: 'https://mobilepssr-api-test-cvx.azurewebsites.net/api',
  support: {
    userGuideUrl: 'https://mobilepssr-test-documents.azure.chevron.com',
  },
  msal: {
    config: {
      auth: {
        clientId: '5b0c9cc5-9292-4c44-858c-ca7fc1929064',
        authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
        redirectUri: `${location.protocol}//${location.hostname}${location.port && ':' + location.port}/`,
        navigateToLoginRequestUrl: true,
        validateAuthority: true,
        postLogoutRedirectUri: `${location.protocol}//${location.hostname}${location.port && ':' + location.port}/`,
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true, // Required for Microsoft Edge and Safari compatibility
      },
    },
    scopes: ['openid', 'profile', 'User.Read'],
    extraScopesToConsent: ['https://mobilepssr-test.azure.chevron.com/user_impersonation'],
  } as MsalConfiguration,
};
